module.exports = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/clone.js
// module id = 73
// module chunks = 168707334958949